import { render, staticRenderFns } from "./assetPlanBaseInfo.vue?vue&type=template&id=54a95b9c&scoped=true"
import script from "./assetPlanBaseInfo.vue?vue&type=script&lang=js"
export * from "./assetPlanBaseInfo.vue?vue&type=script&lang=js"
import style0 from "./assetPlanBaseInfo.vue?vue&type=style&index=0&id=54a95b9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a95b9c",
  null
  
)

export default component.exports